import type { PaymentPort, PaymentPortInput, PaymentResult } from '../domain/ports/payment.port';

/**
 * Mock adapter — simulates Razorpay payment flow.
 * Replace with RazorpayAdapter when the vendor SDK is integrated.
 */
export class MockRazorpayAdapter implements PaymentPort {
  async collect(input: PaymentPortInput): Promise<PaymentResult> {
    // Simulate network latency proportional to amount
    await new Promise((resolve) => setTimeout(resolve, Math.min(input.amountPaise / 100, 2000)));

    return {
      transactionId: `mock_txn_${Date.now()}`,
      status: 'success',
      paidAt: new Date(),
    };
  }
}
